<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { permsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import PermissionsUpdateForm from '@views/roles_management/perms/update-form'
import PermissionsCreateForm from '@views/roles_management/perms/create-form'


export default {
  page: {
    title: 'Permissions',
    meta: [{ name: 'Permissions management', content: 'Permissions management' }],
  },
  components: { Layout, PageHeader, BaseDatatable,
    PermissionsUpdateForm, PermissionsCreateForm },
  data() {
    return {
      title: 'Permisos',
      breadcrumbs: [
        {
          text: 'Administración',
        },
        {
          text: 'Permisos',
          active: true,
        },
      ],
      sortBy: 'permission_type',
      sortDesc: false,
      tableHeaders: [
        {
          key: 'permission__name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'permission__codename',
          label: 'Codename',
          sortable: true
        },
        {
          key: 'description',
          label: 'Descripción',
          sortable: true
        },
        {
          key: 'permission_type',
          label: 'Tipo de permiso',
          sortable: true
        },
        {
          key:'actions', 
          label: 'Acciones'
          }
      ],
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      createForm: {
          name: '',
          codename: '',
          description: ''
      },
      updateForm: {
          url: '',
          name: '',
          codename: '',
          description: ''
      },
      action : '',
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false
    }
  },
  validations: {
    updateForm:{
      name: {
        required,
        minLength: minLength(4)
      },
      codename: {
        required
      },
    },
    createForm: {
      name: {
        required,
        minLength: minLength(4)
      },
      codename: {
        required
      },
    },
  },
  methods: {
    ...permsMethods,   

    myProvider(ctx) {
      const promise = this.fetchPerms(this.$table_params(ctx))
      return promise.then(data => {
        return data
      }).catch(error => {
        this.$axios_error_noty(error, this)
        return []
      })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Permiso: ${item.permission.name}`
      const promise = context.fetchPermsDetail(item.url)
      return promise.then(data => {
        context.detailModal.content = data
        context.detailModalShow = !context.detailModalShow
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create'){
        this.createForm.name = ''
        this.createForm.codename = ''
        this.createForm.description = ''
        this.$v.createForm.$reset();
      }else {
        this.updateForm.url = ''
        this.updateForm.name = ''
        this.updateForm.codename = ''
        this.updateForm.description = ''
        this.$v.updateForm.$reset();
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create'){
        this.action = 'create'
        this.createUpdateModal.title = `Nuevo Permiso`
      }else if (action === 'update'){
        this.action = 'update'
        this.createUpdateModal.title = `Actualizar Permiso`
        this.updateForm.url = item.url
        this.updateForm.name = item.permission.name
        this.updateForm.codename = item.permission.codename
        this.updateForm.description = item.description
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch()
      }
      let form = context.action === 'create' ? context.createForm : context.updateForm
      let completeForm = {
        'url': form.url,
        'permission': form,
        'description': form.description,
        'permission_type' : 2
      }
      const promise = context.createUpdatePerms(completeForm)
      return promise.then(data => {
        if (completeForm.url){
          context.$generate_toast(context, 'success', 'Permiso actualizado correctamente')
        }else{
          context.$generate_toast(context, 'success', 'Permiso creado correctamente')
        }
        context.createUpdateModalShow = !context.createUpdateModalShow
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },    
    deletePerm() {
      let context = this
      context.isSubmitting = true
      const promise = context.deletePerms(context.toDelete.url)
      return promise.then(data => {
        context.$generate_toast(context, 'success', 'Permiso Borrado')
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
  }
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="breadcrumbs"
    />

    <div class="row">
      <div class="col-md-12">
        <b-card >
            <b-button
              variant="info"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
              >
              <i class="fe-plus">Nuevo</i>
          </b-button>
          <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              :sortby="sortBy"
              :sortdesc="sortDesc"
              >
              <template v-slot:cell(permission__name)="data">
                {{data.item.permission.name}}
              </template>
              <template v-slot:cell(permission__codename)="data">
                {{data.item.permission.codename}}
              </template>
              <template v-slot:cell(permission_type)="data">
                {{data.item.permission_type_verbose}}
              </template>
              <template v-slot:cell(actions)="row">
                  <b-button-group size="xs">
                    <b-button
                      :id="`info-btn-${row.index}`"
                      variant="outline-info btn-transparent"
                      size="xs"
                      :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                      @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                      >
                      <i v-if="!actionsLoadings[`info-btn-${row.index}`]" class="fe-info fe-2x"></i>
                      <b-spinner
                        v-if="actionsLoadings[`info-btn-${row.index}`]"
                        small
                        label="Spinning"
                        variant="info"
                        >
                      </b-spinner>
                    </b-button>
                    <b-tooltip
                      :target="`info-btn-${row.index}`"
                      triggers="hover"
                      variant="info">
                      Info
                    </b-tooltip>
                    <b-button
                      v-if="row.item.permission_type === 2"
                      :id="`update-btn-${row.index}`"
                      :disabled="isSubmitting"
                      variant="outline-warning btn-transparent"
                      size="xs"
                      @click="openCreateUpdateModal(row.item, row.index, 'update')"
                      >
                      <i class="fe-edit fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      v-if="row.item.permission_type === 2"
                      :target="`update-btn-${row.index}`"
                      triggers="hover"
                      variant="warning">
                      Update
                    </b-tooltip>

                    <b-button
                      v-if="row.item.permission_type === 2"
                      :id="`delete-btn-${row.index}`"
                      :disabled="isSubmitting"
                      variant="outline-danger btn-transparent"
                      size="xs"
                      @click="openDeleteModal(row.item, row.index)"
                      >
                      <i class="fe-x fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      v-if="row.item.permission_type === 2"
                      :target="`delete-btn-${row.index}`"
                      triggers="hover"
                      variant="danger">
                      Delete
                    </b-tooltip>
                    
                  </b-button-group>
              </template>
          </BaseDatatable>
        </b-card>

        <!-- Detail modal -->
        <b-modal 
          :id="detailModal.id"
          v-model="detailModalShow"
          :title="detailModal.title"
          ok-only 
          @hide="resetdetailModal">
          <!-- <pre>{{ detailModal.content }}</pre> -->
          <table class="table-hover table-sm mb-0">
            <tr><th style="text-align:right">Name</th><td>{{_.capitalize(detailModal.content.permission ? detailModal.content.permission.name : "")}}</td></tr>
            <tr><th style="text-align:right">Description</th><td>{{_.capitalize(detailModal.content.description)}}</td></tr>
            <tr><th style="text-align:right">Permission type</th><td>{{_.capitalize(detailModal.content.permission_type_verbose)}}</td></tr>
            <tr>
              <th style="text-align:right">Users members of</th>
              <td v-if="detailModal.content.permission && 'user_set_info' in detailModal.content.permission && detailModal.content.permission.user_set_info.length">
                <ul>
                  <li v-for="(user, index) in detailModal.content.permission.user_set_info" :key="index">
                    {{ user.first_name ? `${user.first_name} ${user.last_name } (${user.username})` : user.username }}
                  </li>
                </ul>
              <td v-else>No users members</td>
            </tr>
            <tr>
              <th style="text-align:right">Miembros de Grupo</th>
              <td v-if="detailModal.content.permission && 'group_set_info' in detailModal.content.permission && detailModal.content.permission.group_set_info.length">
                <ul>
                  <li v-for="(group, index) in detailModal.content.permission.group_set_info" :key="index">
                    {{ _.capitalize(group.name) }}
                  </li>
                </ul>
              <td v-else>No groups members</td>
            </tr>
          </table>
        </b-modal>
        <!-- Create-Update modal -->
        <b-modal 
          :id="createUpdateModal.id"
          v-model="createUpdateModalShow"
          :title="createUpdateModal.title"
          :size="action === 'create' ? 'sm' : 'lg'"
          >
            <PermissionsUpdateForm 
              v-if="action === 'update'" 
              :validator="$v.updateForm"
              :onformsubmit="onFormSubmit"
              :form="updateForm">
            </PermissionsUpdateForm>
            <PermissionsCreateForm 
              v-if="action === 'create'" 
              :validator="$v.createForm"
              :onformsubmit="onFormSubmit"
              :form="createForm">
            </PermissionsCreateForm>
          <template v-slot:modal-footer>
              <b-button
                variant="secondary"
                size="sm"
                class="float-right"
                @click="createUpdateModalShow = !createUpdateModalShow"
              >
                Cancel
              </b-button>
            <b-button
              type="submit"
              form="form"
              size="sm"
              variant="primary"
              :disabled="action === 'create' ? $v.createForm.$invalid || isSubmitting : $v.updateForm.$invalid || isSubmitting"
            >
              <span
                v-if="!isSubmitting"
                >
                {{ $t('submit') }}
              </span>
              <b-spinner
                v-if="isSubmitting"
                small
                label="Spinning"
                variant="light"
                >
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
        <!-- Delete modal -->
        <b-modal
          id="delete-modal"
          v-model="deleteModalShow"
          title="Delete permission"
          ok-title="Delete"
          ok-variant="danger"
          @hidden="resetDeleteModal"
          @ok="deletePerm"
          >
          <p>
            Are you sure you want to delete the permission named {{ toDelete ? toDelete.permission ? toDelete.permission.name : '' : '' }} ?
          </p>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel">
              Cancel
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              :disabled="isSubmitting"
              @click="ok">
              <span
                v-if="!isSubmitting"
                >
                {{ $t('delete') }}
              </span>
              <b-spinner
                v-if="isSubmitting"
                small
                label="Spinning"
                variant="light"
                >
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
